/** Stored lime analysis stays a percent. The screen shows a multiplier vs 90% CCE lime. */

export const LIME_MULTIPLIER_MIN = 0.5;
export const LIME_MULTIPLIER_MAX = 3;
export const LIME_MULTIPLIER_STEP = 0.05;

/** m = 90 / E, rounded to 2 dp. 90 → 1.00, 100 → 0.90, 60 → 1.50. */
export function toMultiplier(efficiencyPct: number): number {
  if (!Number.isFinite(efficiencyPct) || efficiencyPct <= 0) return Number.NaN;
  return Math.round((90 / efficiencyPct) * 100) / 100;
}

/** E = 90 / m. The value written back into efficiencyPct / analysis.lime. */
export function fromMultiplier(multiplier: number): number {
  if (!Number.isFinite(multiplier) || multiplier <= 0) return Number.NaN;
  return 90 / multiplier;
}

export function formatMultiplier(efficiencyPct: number): string {
  const multiplier = toMultiplier(efficiencyPct);
  return Number.isFinite(multiplier) ? multiplier.toFixed(2) : "";
}
